export default __webpack_public_path__ + "static/media/report.f974ea6f.png";